import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Router } from '@angular/router';

import { Guid } from 'guid-typescript';
import { NgxSpinnerService } from 'ngx-spinner';
import { sortConfig } from '../model/sortConfig';
import { IdleTimeoutService } from './idletimeout.service';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private isAuthorized: boolean = true;
  public currentUser: any;
  public menus: any = [];
  public menufetch = false;
  public address = '';
  public errMessage = '';
  constructor(
    private baseService: BaseService,
    private router: Router,
    private spinner: NgxSpinnerService,
   
  ) {
    this.SetLogedUser();
  }

  private SetLogedUser(): void {
    var storedData = localStorage.getItem('wt');
    if (storedData) {
      this.currentUser = JSON.parse(storedData);
      if (this.currentUser) {
        this.isAuthorized = true;
        // this.router.navigateByUrl('/');
      } else {
        this.isAuthorized = false;
      }
    } else {
      this.isAuthorized = false;
    }
  }

  public IsAuthorizedUser(): boolean {
    if (this.isAuthorized && this.menus.length == 0 && !this.menufetch) {
      this.GetMenus();
    }
    return this.isAuthorized;
  }

  public HaveToken(userId: any): boolean {

    var storedData = localStorage.getItem(userId);
    if (storedData == null) {
      return false;
    }
    var dd = new Date(storedData);
    var cuDate = new Date();
    if (dd < cuDate) {
      return false;
    }

    return true;
  }

  public refreshToken(){
    var data = localStorage.getItem('wuc');
    if(data){
     var request= JSON.parse( atob(data));
      if(request){
       {
        request.daappsessionstate=Guid.create().toString()}
        this.baseService.postLogin(request, 'auth/authenticate').subscribe((x) => {
          localStorage.setItem('wt', JSON.stringify(x));
        });
       }
    }
  }

  public AuthenticateUser(userCredential: any): void {
    var data = {
      action: 'wildauth',
      appid: '16',
      daappsessionstate: Guid.create().toString(),
      password: btoa(userCredential.password),
      username: btoa(userCredential.email),
    };
    this.spinner.show();
    this.errMessage = '';
    this.baseService.postLogin(data, 'auth/authenticate').subscribe((x) => {
      var usercre = btoa(JSON.stringify(data));
  
      localStorage.setItem('wuc', usercre)
      if (x) {
        if (x.errorMessage) {
          this.errMessage = 'Invalid User Name or password..';
          this.spinner.hide();
        } else {
          if (this.HaveToken(x.User_ID)) {
            localStorage.setItem('wt', JSON.stringify(x));
            this.SetLogedUser();
            this.spinner.hide();
          } else {
            localStorage.setItem('wtt', JSON.stringify(x));
            this.GenerateToken({ Email: x.User_Name, Token: '' }).subscribe(xx => {
              this.spinner.hide();
              this.router.navigateByUrl('/token');
            });

          }
        }
      } else {
        alert('Invalid user name or password');
        this.spinner.hide();
      }
    });
  }

  public LogOut(): void {
    // this.signalR.DisconnectMe();
    this.menufetch = false;
    localStorage.removeItem("wt");
    localStorage.removeItem("menu");
    sessionStorage.removeItem("maintenance1Dismissed");
    this.menus = [];
    this.SetLogedUser();
    this.router.navigateByUrl('/');
  }

  public GetMenus(): void {
    this.menufetch = true;
    this.spinner.show();
    let menu = localStorage.getItem('menu');
    if (menu == null) {
      let data = {
        AdminUser: this.currentUser.RoleCode,
        AgencyId: this.currentUser.Agency_ID,
        SecurityFlagId: this.currentUser.Security_Flags_ID,
      };
      this.baseService.post(data, 'api/MenuList').subscribe((menus) => {
        this.spinner.hide();
        this.menus = menus;
        this.menus.forEach((element: any) => {
          element.ahref = element.ahref.replace('#', '').toLowerCase();
        });
        localStorage.setItem('menu', JSON.stringify(menus));
      });



    } else {
      this.spinner.hide();
      this.menus = JSON.parse(menu);
    }
  }

  public DeleteUser(data: any) {
    return this.baseService.post(data, 'api/RemovePersonEmployment');
  }

  public ChangePassword(data: any) {
    return this.baseService.post(data, 'api/SetPassword');
  }

  public GetEmployeeInfo(data: any) {
    return this.baseService.post(data, 'api/GetAgencyPersonInfo');
  }

  public UpdateEmployeeInfo(data: any) {
    return this.baseService.post(data, 'api/SetPersonName');
  }

  public UpdateUser(data: any) {
    return this.baseService.post(data, 'api/UpdateUser');
  }
  public GetAgencyPermissions(data: any) {
    return this.baseService.post(data, 'api/GetAgencyPermissionList');
  }
  public SetAgencyPermissions(data: any) {
    return this.baseService.post(data, 'api/SetAgencySecurity');
  }

  public GetRoles() {
    return this.baseService.get('api/UserRole');
  }

  public GetUserPermissions(data: any) {
    return this.baseService.post(data, 'api/GetUserPermissionList');
  }

  public GetUserDetails(data: any) {
    return this.baseService.post(data, 'api/GetUserDetails');
  }

  public GetAgencySecurityFlag(data: any) {
    return this.baseService.post(data, 'api/GetAgencySecurityFlag');
  }
  public CreateNewUser(data: any) {
    return this.baseService.post(data, 'api/CreateNewUser');
  }

  public VerifyToken(data: any) {
    return this.baseService.post(data, 'api/Token');
  }
 public GetTimeLimit() {
    return this.baseService.get('api/Token/timelimit');
  }
  public ValidateUser() {
    var dd = localStorage.getItem("wtt");
    if (dd) {
      var userObj = JSON.parse(dd);
      var currDate = new Date();
      currDate.setDate(currDate.getDate() + 30);
      localStorage.setItem(userObj.User_ID, currDate.toDateString());
      localStorage.setItem("wt", dd);
      this.SetLogedUser();
      localStorage.removeItem("wtt");
    }

  }
  public GenerateToken(data: any) {
    return this.baseService.post(data, 'api/GenerateToken');
  }


  public SortBy(items: any, sortConfig: sortConfig) {
    items = [...items.sort((a: any, b: any) => {
      let result = 0;
      if (a[sortConfig.SortBy] < b[sortConfig.SortBy]) {
        result = -1;
      }
      if (a[sortConfig.SortBy] > b[sortConfig.SortBy]) {
        result = 1;
      }
      return result * sortConfig.SortOrder;
    })];

  }
}
